interface EHTMLElement extends HTMLElement {
  /**
   * alias for appendChild
   */
  ac: (e: HTMLElement) => EHTMLElement;
  /**
   * remove the element from DOM
   */
  rem: () => EHTMLElement;
  /**
   * hide the element (style.display = "none")
   */
  hide: () => EHTMLElement;
  /**
   * rehide the element (style.display = "")
   */
  rehide: () => EHTMLElement;
}

/**
 * creates an extended HTMLElement with some DOM helpers.
 * See {@link EHTMLElement} for details which methods are added
 * @param tagName which type f.e. div or img
 * @param content optional define directly a content (string | HTMLElement | EHTMLElement)
 * @returns the EHTMLElement
 * @author CTO
 */
export function crE(tagName: string, content?: string | HTMLElement | EHTMLElement): EHTMLElement {
  const e = document.createElement(tagName);
  if (content) {
    if (typeof content === "string" || typeof content === "number") {
      e.innerText = content;
    } else {
      e.appendChild(content);
    }
  }
  return extendElement(e);
}

function extendElement(e: HTMLElement): EHTMLElement {
  const x = e as EHTMLElement;
  x.ac = function (e: HTMLElement) {
    this.appendChild(e);
    return this;
  };
  x.rem = function () {
    this?.parentNode?.removeChild(this);
    return this;
  };
  x.hide = function () {
    this.style.display = "none";
    return this;
  };
  x.rehide = function () {
    this.style.display = "";
    return this;
  };
  return x;
}
